import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'ban', 'Ban', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M5.7 5.7l12.6 12.6"}]]);